'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractProfileName = extractProfileName;
/**
 * Utility to extract a profile's name.. Why the fuck is this even needed?
 *
 * @param  {object} authProfile
 * @return {string}
 */
function extractProfileName(authProfile) {
  var name = authProfile.name;
  var userMeta = authProfile.user_metadata || {};
  if (userMeta && userMeta.given_name) {
    name = userMeta.given_name + ' ' + (userMeta.family_name || authProfile.family_name);
  }

  if (authProfile.given_name) {
    name = (userMeta.given_name || authProfile.given_name) + ' ' + (userMeta.family_name || authProfile.family_name);
  }

  return name;
}
//# sourceMappingURL=auth0Util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/utils/auth0Util.js
// module id = 634
// module chunks = 0